// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"ValidationError_ErrorMessage__YFVif"};